import { inject, Injectable } from '@angular/core';
import {
  NavData,
  NavProfileData,
  NavSection,
  UserInfo,
} from '@terminus-ui/nav';
import { BehaviorSubject, Observable, of, switchMap } from 'rxjs';
import { NavItemAccessService } from './nav-item-access.service';

@Injectable()
export class NavItemService {
  private navItemsAccessService = inject(NavItemAccessService);

  private allNavItems$: BehaviorSubject<NavData> = new BehaviorSubject<NavData>(
    [],
  );
  filteredNavItems$ = this.allNavItems$.pipe(
    switchMap((items) =>
      this.navItemsAccessService.filterNavItemsByRestrictions$(items),
    ),
  );

  navProfileData$: BehaviorSubject<NavProfileData> =
    new BehaviorSubject<NavProfileData>([]);

  appName$: BehaviorSubject<string> = new BehaviorSubject<string>('');

  private lastUserObserable$: BehaviorSubject<Observable<UserInfo | null>> =
    new BehaviorSubject<Observable<UserInfo | null>>(of(null));

  user$: Observable<UserInfo | null> = this.lastUserObserable$.pipe(
    switchMap((obs) => obs),
  );

  setNavItems(navItems: NavSection[]): void {
    this.allNavItems$.next(navItems);
  }

  setUser(user: Observable<UserInfo | null>): void {
    this.lastUserObserable$.next(user);
  }

  setAppName(appName: string): void {
    this.appName$.next(appName);
  }
}
